import { useSelector } from 'react-redux';
import { selectEstimationChartState } from '../../../selectors/estimationChart';
import { EChange } from '../../../types/redux/estimationChart';
import GrowSvg from '../assets/grow.svg';
import DownSvg from '../assets/down.svg';
import NoChangesSvg from '../assets/no-changes.svg';

export interface IUseGetChanges {
  text: string;
  icon: string;
}
/** Хук возвращает текст и иконку для отображения изменения цены */
export const useGetChanges = (): IUseGetChanges | null => {
  const { isError, data } = useSelector(selectEstimationChartState);

  if (isError || !data) {
    return null;
  }

  const title = data?.title;

  if (title?.change === EChange.Increase) {
    return {
      text: `+${title.changeValue}`,
      icon: GrowSvg,
    };
  }

  if (title?.change === EChange.Decrease) {
    return {
      text: `−${title.changeValue}`,
      icon: DownSvg,
    };
  }

  return {
    text: '0%',
    icon: NoChangesSvg,
  };
};
